var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{attrs:{"fluid":""}},[_c('b-row',{attrs:{"no-gutters":""}},[_c('b-col',[_c('router-link',{staticClass:"h6 font-weight-bold",attrs:{"to":"/","tag":"a"}},[_vm._v("← Back to roles")])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }